module.exports = "/_next/static/images/sercel-32f23a5e6b24c0a03715537fdb47ec60.jpg";